import React, { useState } from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import Ibex from "../images/Ibex.jpg";
import Image from '../mainPageComponents/image.js';
import TraversePosts from '../articleComponents/navigation';

const today = new Date("1, 26, 2021").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function ByAnyOtherName() {

const [name, setName] = useState({
  firstName: '',
  lastName: ''
})

const [items, setItems] = useState([])

const addItem = () => {
  setItems([...items, {id: items.length, value: Math.floor(Math.random() * 10 + 1) }])
}

  return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="By Any Other Name" desc="Peace with Israel and the Arab states mean our entire region can coalesce into a huge economic powerhouse, even if, like Europe, we all maintain our unique language, culture, cuisine, and religion. But what will we call it?" 
URL="https://highway-60.firebaseapp.com/articles/by-any-other-name" imageURL={Ibex} />

        <h1 id="top" style={{marginTop: '2em'}}>By Any Other Name</h1>

<Image picURL={Ibex} />

<BioLine />
<p>{today}</p>


<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/by-any-other-name" title="By Any Other Name" hashtag="#highway60" hashtagArray={["writing", "Israel"]} 
via="TheHighway60" desc="Peace with Israel and the Arab states mean our entire region can coalesce into a huge economic powerhouse, even if, like Europe, we all maintain our unique language, culture, cuisine, and religion. But what will we call it?" />
</div>

<p>
The Times of Israel just published my article about a new name for an old region. The term "The Middle East" comes from the British Colonial office in 1850. 
</p>

<p>
Now that there is peace and economically, we should develop into a regional bloc, we should call ourselves something better than a piece of a World Atlas. 
</p>

<p>
Enjoy. You can view it <a href="https://blogs.timesofisrael.com/a-new-name-for-a-new-day/" target="_blank">right here</a>.
</p>

<p>Form Handling:</p>

<p>This is a class I am taking and I need somewhere to put my form. Here is something that looks pointless, but I did a little state work with forms on it.</p>

<form>
  <input type="text" value={name.firstName} onChange={e => setName({
    ...name, firstName: e.target.value
  })}/>
  <input type="text" value={name.lastName} onChange={e => setName({
...name, lastName: e.target.value  
})}/>
</form>

<h2>Your first name is: {name.firstName}</h2>
<h2>Your last name is: {name.lastName}</h2>

<button onClick={addItem}>Pick a number</button>

<ul>
  {
    items.map(item => <li key={item.id}>id: {item.id} value: {item.value}</li>)
  }
</ul>

<h2>{JSON.stringify(items)}</h2>

<TraversePosts prevURL="/articles/a-state-is-born" nextURL="../articles/amazon-and-al-capone"/>

<Connect />
</motion.div>
  );
}

export default ByAnyOtherName;
